import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    title: 'Bot is not available',
    description: "Remove other bots' names from your Telegram name, otherwise the ban will be permanent.",
  },
  ru: {
    title: 'Бот тебе не доступен',
    description: 'Убери имена других ботов из своего имени в Telegram, иначе бан будет навсегда.',
  },
  uz: {
    title: 'Bot siz uchun mavjud emas',
    description: 'Telegram ismingizdan boshqa botlarning nomlarini olib tashlang, aks holda ban abadiy boʻladi.',
  },
  fa: {
    title: 'ربات در دسترس نیست',
    description: 'نام ربات‌های دیگر را از نام تلگرامت پاک کن، وگرنه مسدودی دائمی می‌شود.',
  },
  pt: {
    title: 'O bot não está disponível para você',
    description: 'Tire os nomes de outros bots do seu nome no Telegram, senão o banimento vai ser permanente.',
  },
  tr: {
    title: 'Bot senin için kullanılamıyor',
    description: 'Telegram adından diğer botların adlarını kaldır, yoksa yasak kalıcı olur.',
  },
  uk: {
    title: 'Бот тобі недоступний',
    description: 'Прибери імена інших ботів зі свого імені в Telegram, інакше бан буде назавжди.',
  },
  de: {
    title: 'Der Bot ist für dich nicht verfügbar',
    description: 'Entferne die Namen anderer Bots aus deinem Telegram-Namen, sonst bleibt die Sperre dauerhaft.',
  },
  es: {
    title: 'El bot no está disponible para ti',
    description: 'Quita los nombres de otros bots de tu nombre en Telegram; si no, el baneo será permanente.',
  },
  pl: {
    title: 'Bot jest dla ciebie niedostępny',
    description: 'Usuń nazwy innych botów ze swojego imienia w Telegramie, w przeciwnym razie ban będzie na stałe.',
  },
});
